<template>
  <div class="bar-chart-container pt-5 pr-5">
    <BarChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import {Bar as BarChartGenerator} from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'BarChart',
  components: {
    BarChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: undefined,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    isNow: {
      type: Array,
      required: true,
    },
    isHREvaluate: {
      type: Array,
      required: true,
    },
    isTakeLater: {
      type: Array,
      required: true,
    },
    isNowPercent: {
      type: Array,
      required: true,
    },
    isHREvaluatePercent: {
      type: Array,
      required: true,
    },
    isTakeLaterPercent: {
      type: Array,
      required: true,
    },
    noActionPercent: {
      type: Array,
      required: true,
    },
     noAction: {
      type: Array,
      required: true,
    },
     
  },
  computed: {
    chartData() {
      return {
        labels: [
        ['Before', 'Screening'],
        ['Before', 'Mains'],
        ['Before', 'Demo'],
      ],
        datasets: [
           {
            label: 'No Action',
            backgroundColor: '#E0E0E0',
            data: this.noActionPercent,
            actualData: this.noAction,
          },
          {
            label: 'Now-Not Started',
            backgroundColor: '#439AFF',
            data: this.isNowPercent,
            actualData: this.isNow,
          },
          {
            label: 'Later',
            backgroundColor: '#5AD684',
            data: this.isTakeLaterPercent,
            actualData: this.isTakeLater,
          },
          {
            label: 'HR to Revert',
            backgroundColor: '#F5B4AA',
            data: this.isHREvaluatePercent,
            actualData: this.isHREvaluate,
          },
        ],
      };
    },
  },
  mounted() {
    this.updateFontSizeForBreakpoint();
    window.addEventListener('resize', this.updateFontSizeForBreakpoint);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateFontSizeForBreakpoint);
  },
  methods: {
    updateFontSizeForBreakpoint() {
      const width = window.innerWidth;
      const isSmall = width <= 1380;

      // Update chartOptions plugin font sizes
    
      this.chartOptions.plugins.datalabels.font.size = isSmall ? 8 : 10;
    },
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              font: {
                size: 12,
              },
              usePointStyle: true,
              pointStyle: 'rect',
            },
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const dataset = context.dataset;
                const actualValue =
                  dataset.actualData?.[context.dataIndex] || 0;
                const percentValue = context.parsed.y || 0;
                return `${dataset.label}: ${percentValue.toFixed(
                  1
                )}% (${actualValue})`;
              },
            },
          },
          datalabels: {
            anchor: 'end',
            align: 'start',
            offset: -20,
            formatter: (value) => {
              return `${value.toFixed(1)}`; // Directly show the percent value
            },
            font: {
              size: 12,
            },
            color: '#000',
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,
            min: 0,
            max: 100, // Always show 100% as max
            ticks: {
              callback: function (value) {
                return value; // Add percent symbol to ticks
              },
            },
            grid: {
              display: false,
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped>
.bar-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: auto;
  position: relative;
}
</style>
